export default __webpack_public_path__ + "static/metric_details-af4cafd7812726e0531cdca318bc4063.png";